import { render, staticRenderFns } from "./gant-table.vue?vue&type=template&id=5baec814&scoped=true"
import script from "./gant-table.vue?vue&type=script&lang=js"
export * from "./gant-table.vue?vue&type=script&lang=js"
import style0 from "./gant-table.vue?vue&type=style&index=0&id=5baec814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baec814",
  null
  
)

export default component.exports